import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { EditionService } from "@webapp/accounts/services/edition/edition.service";

@Directive({
  selector: "[editionFeature]",
})
export class EditionFeatureDirective implements OnInit {
  /**
   * Name of the feature to check if it is enabled.
   */
  @Input()
  public editionFeature: string;

  constructor(private templateRef: TemplateRef<unknown>, private container: ViewContainerRef, private editionService: EditionService) {}

  public ngOnInit(): void {
    this.container.clear();

    if (this.editionService.isFeatureEnabled(this.editionFeature)) {
      this.container.createEmbeddedView(this.templateRef);
    } else {
      this.container.clear();
    }
  }
}
